import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/auth-layout';
import { useAuth } from '@/components/auth-provider';
import { GuestLayout } from '@/components/guest-layout';
import { StoryAuthorPage } from '@/components/story-author-page';
import { StoryGuestPage } from '@/components/story-guest-page';
import { StoryPersonalPage } from '@/components/story-personal-page';
import { storyByIdQueryOptions } from '@/shared/queries';

export const Route = createFileRoute('/stories_/$storyId')({
  component: RouteComponent,
  loader: async ({ params, context: { queryClient } }) => {
    const story = await queryClient.ensureQueryData(
      storyByIdQueryOptions(params.storyId),
    );

    return {
      crumb: story.data.template
        ? story.data.template.displayName
        : 'storyTemplate.custom',
    };
  },
});

function RouteComponent() {
  const { storyId } = Route.useParams();
  const query = useQuery(storyByIdQueryOptions(storyId));

  const auth = useAuth();

  if (auth.isPending) {
    return <>Auth Loading</>;
  }

  if (auth.isError) {
    return (
      <GuestLayout storyId={storyId}>
        <StoryGuestPage storyId={storyId} />
      </GuestLayout>
    );
  }

  if (query.data?.data.isPersonal) {
    return (
      <AuthLayout>
        <StoryPersonalPage storyId={storyId} />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <StoryAuthorPage storyId={storyId} />
    </AuthLayout>
  );
}
